import {createGlobalStyle, css} from 'styled-components';

const globalCss = css`
  body {
    * {
      font-family: ${props => (props.theme.bodyFontFamily)};
      font-size: ${props => (props.theme.bodyFontSize)};
      color: ${props => props.theme.bodyFontColor};
      letter-spacing: ${props => props.theme.letterSpacing};
    }

    h1, h2 {
      font-family: ${props => (props.theme.h1FontFamily)};
      font-size: ${props => (props.theme.h1FontSize)};
      color: ${props => (props.theme.h1FontColor)};
    }

    h3 {
      font-family: ${props => (props.theme.h3FontFamily)};
    }

    a, .link {
      :hover {
        color: ${props => props.theme.linkHoverColor};
      }
    }

    .header {
      margin-left: ${props => props.theme.headerMarginLeft};
    }

    .widgetContent {
      padding: ${props => props.theme.widgetContent?.padding};
    }

    .marginBottom {
      margin-bottom: ${props => props.theme.marginBottom};
    }

    .step1 .marginBottom {
      margin-bottom: ${props => props.theme.marginBottomStep1};

      &:last-child {
        margin-bottom: 0;
      }
    }

    .marginBottomTen {
      margin-bottom: ${props => props.theme.marginBottomTen};
    }

    @media (min-width: 1025px) {
      .container {
        grid-template-areas: ${props => props.theme.gridTemplateAreasContainer};
        grid-template-columns: ${props => props.theme.gridTemplateColumnsContainer};
      }
      .containerLeft {
        grid-template-areas: ${props => props.theme.gridTemplateAreasContainerLeft};
        grid-template-columns: ${props => props.theme.gridTemplateColumnsContainerLeft};
      }
    }

    .container, .containerLeft {
      height: ${props => props.theme.height};
      ${props => props.theme.maxWidthContainer && `
        width: 100%;
        max-width: ${props.theme.maxWidthContainer};
        justify-self: center;
      `}
    }
  }
`;

const GlobalStyle = createGlobalStyle`
  ${globalCss}
`;

export default GlobalStyle;
